import Page from '../../classes/Page'
import { app } from '../../utils/store'

export default class SearchPage extends Page{
    constructor(){
        super({
            id : 'search',
            element: '[data-app-page]',
            // elements: { key : 'nodeElementSelector' }
        })
    }

    create() {
        super.create()
    }
    
    addEventListeners() {
        
    }

    destroy(){ 
        super.destroy()
    }
}